module.exports = __webpack_public_path__ + "static/avatar_top_ad.a2a80077.png";